import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import BouncingLoading from "./BouncingLoading";
import api from "../../api";
import {toast} from "react-toastify";

const TransactionCheck = () => {
    const location = useLocation();
    const [paymentFailed, setPaymentFailed] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [unknownParams, setUnknownParams] = useState(false);
    const [verifyError, setVerifyError] = useState(false);
    const [loading, setLoading] = useState(true);
    
    const params = new URLSearchParams(location.search);
    const success = params.get('success');
    const status = params.get('status');
    const trackId = params.get('trackId');
    const orderId = params.get('orderId');
    
    useEffect(() => {
        const requestData = {
            success: success,
            status: status,
            trackId: trackId,
            orderId: orderId
        }
        
        if (!success || !status || !trackId || !orderId) {
            setUnknownParams(true);
            setLoading(false);
        }
        
        if (success !== '1') {
            setPaymentFailed(true);
            setLoading(false);
        }
        
        api.post('/wallet/zibal/verify', requestData)
            .then(response => {
                setPaymentSuccess(true);
                setLoading(false);
                setTimeout(() => {
                    window.location.href = '/user-panel';
                }, 5000);
            })
            .catch(error => {
                toast.error(error.response.data.error);
                setVerifyError(true);
                setLoading(false);
            });
    }, [location]);
    
    return (
        <div style={{height: '100vh'}}>
            {loading ? <BouncingLoading/> : (
                <div className="container h-100 items-center">
                    <div className="card rounded-4 border-0 my-auto">
                        <div className="card-body text-center">
                            <p className="text-bold">شناسه پرداخت شما : <span>{trackId}</span></p>
                            {paymentSuccess && (
                                <div>
                                    <h4 className="text-success">پرداخت با موفقیت انجام شد</h4>
                                    <p>پرداخت شما با موفقیت انجام شد و مبلغ به حساب شما افزوده شد</p>
                                </div>
                            )}
                            {paymentFailed && (
                                <div className="text-center">
                                    <h4 className="text-danger">پرداخت ناموفق بود</h4>
                                    <p>پرداخت شما ناموفق بود. لطفا دوباره تلاش کنید</p>
                                </div>
                            )}
                            {unknownParams && (
                                <div className="text-center">
                                    <h4 className="text-danger">پارامترهای نامعتبر</h4>
                                    <p>پارامترهای ارسالی از درگاه پرداخت نامعتبر است</p>
                                </div>
                            )}
                            {verifyError && (
                                <div className="text-center">
                                    <h4 className="text-danger">خطا در تایید پرداخت</h4>
                                    <p>خطایی در تایید پرداخت رخ داده است.</p>
                                    <p>برای بررسی با شماره ی <span>۰۹۳۷۶۹۴۰۴۳۰</span> تماس بگیرید.</p>
                                </div>
                            )}
                            <div className="mt-4">
                                <button className="btn btn-primary"
                                        onClick={() => window.location.href = '/user-panel'}>بازگشت به
                                    صفحه اصلی
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TransactionCheck;
